export default __webpack_public_path__ + "static/media/ice-cream.ab5e069f.jpg";